import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';
import { ensurePxUnit } from '../../utils/mobileUtils';

export const FileAttachmentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: ${({ renderMode, height }) => (renderMode === 'preview' ? height : '100%')};
  flex-direction: ${({ isButtonLeft }) => (isButtonLeft ? 'row' : 'row-reverse')};
`;

export const StatusLabel = styled.span`
  white-space: nowrap;
  flex-grow: 1;
  text-align: left;
  ${Styles.FontStyles}
`;